import { Container } from "@mui/material";
import { Text } from "components/atoms/text";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

interface Props {}

const NoPostsEmptyState: FunctionComponent<Props> = ({}) => {
  const { t } = useTranslation();

  return (
    <Container
      sx={{
        padding: "40px 0px",
      }}
    >
      <Text variant="h5" textAlign={"center"}>
        {t("empty_states.no_posts.title")}
      </Text>
      <Text variant="subtitle1" textAlign={"center"}>
        {t("empty_states.no_posts.subtitle")}
      </Text>
    </Container>
  );
};

export default NoPostsEmptyState;
